<template>
    <div class="single flex flex-just-between">
        <div class="fz-13 flex">
            <p class="mr-8 yx-color-text-regular nowrap">您已选择报名</p>
            <div :class="['activity', isopen ? 'isopen' : '', 'mb-12']">
                <el-popover
                    placement="bottom"
                    width="400"
                    trigger="hover"
                    v-for="item,index in selectionShopArr"
                    :key="index"
                >
                    <div class="box fz-13">
                        <div class="header flex">
                            <p class="yx-color-text-primary">{{ item.activity_name }}</p>
                            <p class="nowrap ml-20 yx-color-text-secondary"><span class="mr-6">{{ item.apply_end_time }}</span>截止</p>
                        </div>
                        <p class="mt-10 fz-13 yx-color-text-primary">{{ item.institution_name }}</p>
                        <div class="content">
                            <p class="mt-12"><span class="yx-color-text-regular">推广时间：</span><span class="yx-color-text-primary">{{ item.promote_start_time + ' - ' + item.promote_end_time }}</span></p>
                            <p class="mt-12"><span class="yx-color-text-regular">活动要求：</span><span class="yx-color-text-primary">{{ item.activity_desc }}</span></p>
                            <p class="mt-12"><span class="yx-color-text-regular">最低佣金：</span><span class="yx-color-text-primary">{{ item.commission_rate }}%</span></p>
                            <p class="mt-12"><span class="yx-color-text-regular">服务费：</span><span class="yx-color-text-primary">{{ item.service_rate }}%</span></p>
                            <p class="mt-12"><span class="yx-color-text-regular">预估评价成绩销售额(元)：</span><span class="yx-color-text-primary">每单品<span class="ml-6 mr-6">{{ item.estimated_single_sale }}</span></span></p>
                        </div>
                    </div>
                    <span class="PingFang item" slot="reference">
                        {{ item.activity_name + '、'}}
                    </span>
                </el-popover>
            </div>
        </div>
        <div class="flex fz-13 nowrap">
            <p>
                共<span class="yx-color-primary ml-6 mr-6">{{ selectionShopArr.length }}</span>个团长活动
            </p>
            <p class="pointer open ml-20" @click="open('open')">
                <span class="mr-6">展开</span>
                <i class="el-icon-arrow-down"></i>
            </p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        selectionShopArr: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            isopen: false
        }
    },
    methods: {
        open(key) {
            this.isopen = !this.isopen
        }
    }
}
</script>
<style lang="less" scoped>
.right {
    margin-left: 30px;
    display: flex;
    border-left: 1px solid #F8F8F8;
    padding: 15px 20px 20px 30px;
}
.open:hover {
    color: @color-primary;
}
.activity {
    height: 18px;
    overflow: hidden;
}
.isopen {
    height: auto;
}
.nowrap {
    white-space: nowrap;
}
.item:hover {
    color: @color-primary;
    cursor: default;
}
.box {
    padding: 10px 12px;
}
</style>